import { useParams, Link } from "react-router-dom";
import { DEMOS } from "@/data/industries";
import DemoWebsite from "@/components/demo/DemoWebsite";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import { waLink } from "@/data/site";
import { ArrowLeft } from "lucide-react";

const DemoPage = () => {
  const { slug } = useParams();
  const demo = DEMOS[slug];

  if (!demo) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center bg-[#FDFBF7] px-4 text-center" data-testid="demo-not-found">
        <h1 className="font-heading text-3xl font-bold text-[#3E2723]">Demo not found</h1>
        <p className="mt-3 text-[#5D4037]">This demo doesn't exist yet. Explore our demo showroom instead.</p>
        <Link to="/#demos" className="btn-primary mt-6">
          <ArrowLeft className="h-4 w-4" /> Back to Demos
        </Link>
      </div>
    );
  }

  return (
    <>
      <DemoWebsite demo={demo} slug={slug} />
      <WhatsAppFloat message={demo.whatsappMessage || undefined} />
    </>
  );
};

export default DemoPage;
